module.exports = __webpack_public_path__ + "media/6.51ba7ecf.wav";